export const getListIconStyle = (color: string | null) => {
  if (!color) {
    return {
      "background-color": "rgba(var(--accent), 0.12)",
      color: "var(--accent)",
    };
  }
  const cleanColor = color.startsWith("#") ? color : `#${color}`;
  return {
    "background-color": `${cleanColor}20`,
    color: cleanColor,
  };
};
